import React from 'react';
import { Table } from 'react-bootstrap';

const ShitSummaryReportFilterDataTable = ({
  data
}) => {


  console.log(data)
  const tableHeader = () => {
    return [
      'Trabajados',
      'Doble Turno',
      'Noche',
      'Domingos',
      'Feriados',
      'Feriados Irrenunciables'
    ];
  };

  const renderData = () => {
    return (
      <>

        <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              {tableHeader().map(itemHeader => (
                <th className="text-center align-middle" key={itemHeader}>
                  {itemHeader}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center align-middle">{data.workers_per_day}</td>
              <td className="text-center align-middle">{data.days_with_double_shifts}</td>
              <td className="text-center align-middle">{data.night_shifts}</td>
              <td className="text-center align-middle">{data.sundays_worked}</td>
              <td className="text-center align-middle">{data.holidays_worked}</td>
              <td className="text-center align-middle">{data.holidays_worked_non_waivable}</td>
            </tr>
          </tbody>
        </Table>

      </>
    );
  };

  return <>{renderData()}</>;
};

export default ShitSummaryReportFilterDataTable;
